/* Sticky DESKTOP ATC bar (BS-103) — bottom slide-up, Direction A.
   Desktop-only (>=768px); mobile keeps batida-sticky-atc.js (separate file).
   Appears only after the inline ATC scrolls out of view; hides near the footer
   and when the cart drawer is open. Subtle fade-in (restrained, on-brand).
   Delegates the click to the real inline ATC so ALL size/Napis validation +
   cart-drawer logic flows through unchanged. Self-contained: injects own CSS. */
/* BS-111 (2026-06-08): the bar mirrored only inline.disabled, which Pipeline's
   Alpine re-enables ~100ms after our JS disable — so the desktop sticky CTA let
   shoppers add a cake with an EMPTY required inscription. Now we consult the
   authoritative empty-field state (requiredFieldBlocked) in the disabled mirror
   AND the click guard, and flash the empty field on a blocked tap. */

(function bs103DesktopStickyAtc() {
	if (!document.body || !document.body.classList.contains('template-product')) return;

	var STYLE_ID  = 'batida-sticky-atc-d-css';
	var BAR_ID    = 'batida-sticky-atc-d';
	var ATC_SEL   = '.btn--add-to-cart';
	var PRICE_SEL = '[data-product-price]';
	var TITLE_SEL = '.product__title';
	var IMG_SEL   = '.product__media img, .product__media__inner img, [data-product-media] img';
	var SIZE_SEL  = '.batida-size-card.is-selected';
	var FOOTER_SEL = 'footer.footer, footer, .footer';

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) return;
		var s = document.createElement('style');
		s.id = STYLE_ID;
		s.textContent = [
			'#' + BAR_ID + '{',
				'position:fixed;left:0;right:0;bottom:0;z-index:95;',
				'background:rgba(250,246,241,0.92);',
				'-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);',
				'border-top:1px solid #e3d5ca;',
				'box-shadow:0 -2px 18px rgba(43,32,23,0.07);',
				'opacity:0;transform:translateY(10px);pointer-events:none;',
				'transition:opacity 0.28s ease, transform 0.28s ease;',
				"font-family:'Lato',sans-serif;",
			'}',
			'#' + BAR_ID + '.is-visible{opacity:1;transform:none;pointer-events:auto;}',
			'#' + BAR_ID + ' .bsd-inner{',
				'max-width:1100px;margin:0 auto;padding:10px 24px;',
				'display:flex;align-items:center;gap:16px;',
			'}',
			'#' + BAR_ID + ' .bsd-thumb{',
				'width:46px;height:46px;border-radius:5px;object-fit:cover;',
				'flex:none;background:#f3d9c8;',
			'}',
			'#' + BAR_ID + ' .bsd-meta{flex:1;min-width:0;}',
			'#' + BAR_ID + ' .bsd-name{',
				'font-size:14px;font-weight:700;color:#2b2017;line-height:1.2;',
				'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;',
			'}',
			'#' + BAR_ID + ' .bsd-sub{font-size:12px;color:#8a7868;margin-top:2px;}',
			'#' + BAR_ID + ' .bsd-cta{',
				'flex:none;background:#1F4054;color:#fff;border:none;',
				'padding:12px 26px;border-radius:0;cursor:pointer;',
				'font-size:12px;font-weight:700;letter-spacing:0.04em;',
				'text-transform:uppercase;font-family:inherit;',
				'transition:background 0.15s;white-space:nowrap;',
			'}',
			'#' + BAR_ID + ' .bsd-cta__price{text-transform:none;}',
			'#' + BAR_ID + ' .bsd-cta:hover:not(:disabled){background:#2A5470;}',
			'#' + BAR_ID + ' .bsd-cta:disabled{background:#6B7E8D;cursor:not-allowed;}',
			'body.batida-cart-drawer-open #' + BAR_ID + '{opacity:0 !important;pointer-events:none !important;}',
			'@media (max-width:767px){#' + BAR_ID + '{display:none !important;}}'
		].join('');
		(document.head || document.documentElement).appendChild(s);
	}

	function q(sel) { return document.querySelector(sel); }
	function inlineAtc() { return q(ATC_SEL); }

	/* ---- BS-111: authoritative required-field guards (self-contained) ---- */
	function napisOn() {
		var w = document.querySelectorAll('.selector-wrapper[data-select-label]');
		for (var i = 0; i < w.length; i++) {
			var lbl = (w[i].getAttribute('data-select-label') || '').toLowerCase();
			if (lbl.indexOf('napis') !== -1 || lbl.indexOf('nappis') !== -1 ||
				lbl.indexOf('tabliczka') !== -1 || lbl.indexOf('inscription') !== -1 ||
				lbl.indexOf('inschrift') !== -1 || lbl.indexOf('beschriftung') !== -1 ||
				lbl.indexOf('напис') !== -1) {
				var tak = w[i].querySelector('input[type="radio"][value="TAK" i], input[type="radio"][value="YES" i], input[type="radio"][value="OUI" i], input[type="radio"][value="JA" i], input[type="radio"][value="ТАК" i]');
				return !!(tak && tak.checked);
			}
		}
		return false;
	}
	function crossOn(handle) {
		var cp = document.querySelector('.cross-product[data-canonical-handle="' + handle + '"]') ||
			document.querySelector('.cross-product--' + handle);
		if (!cp) return false;
		var cb = cp.querySelector('.cross-product__checkbox') || cp.querySelector('input[type="checkbox"]');
		return !!(cb && cb.checked);
	}
	function emptyVal(el) { return !el || (el.value || '').trim().length === 0; }
	/* A required add-on field counts only when it's actually shown to the shopper.
	   The personalization card (batida-personalizacja-v2) hides the field's
	   wrapper until its toggle is ON, so offsetParent===null means the add-on
	   isn't selected → not required. */
	function activeEmpty(el) { return !!(el && el.offsetParent !== null) && emptyVal(el); }
	function requiredFieldBlocked() {
		// "napisz swój list" standalone product (z-wiadomoscia) — robust form flag
		if (document.querySelector('form[data-batida-zw-empty="1"]')) return true;
		// cake inscription — variant radio OR personalization toggle (#batida-napis-text)
		var napisEl = document.getElementById('batida-napis-text');
		// Clarity 2 (5.10): the optional "Napis na torcie" add-on ([data-napis-addon]) never greys the bar (same fix as batida-sticky-atc.js)
		if (activeEmpty(napisEl) && !(napisEl.closest && (napisEl.closest('[data-napis-addon]') || napisEl.closest('.v7-napis')))) return true;
		// "write your letter" personalization add-on
		if (activeEmpty(document.querySelector('textarea[name="properties[_Message-Wiadomosc]"]'))) return true;
		// candle digit
		if (activeEmpty(document.querySelector('.cross-product__input-text--candles'))) return true;
		// belt-and-braces: variant-radio napis even if visibility is quirky
		if (napisOn() && emptyVal(document.getElementById('batida-napis-text'))) return true;
		if (window.batidaNapisGuard && typeof window.batidaNapisGuard.isBlocked === 'function' && window.batidaNapisGuard.isBlocked()) return true;
		return false;
	}
	function atcBlocked() {
		var a = inlineAtc();
		if (!a) return true;
		if (a.disabled) return true;
		return requiredFieldBlocked();
	}
	function flashEl(el) {
		if (!el) return;
		try { el.classList.add('batida-input-error'); } catch (e) {}
		try { el.focus(); } catch (e) {}
		try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
	}
	function flashBlocked() {
		var n = document.getElementById('batida-napis-text'); if ((activeEmpty(n) && !(n.closest && (n.closest('[data-napis-addon]') || n.closest('.v7-napis')))) || (napisOn() && emptyVal(n))) { flashEl(n); return true; }
		var letter = document.querySelector('textarea[name="properties[_Message-Wiadomosc]"]'); if (activeEmpty(letter)) { flashEl(letter); return true; }
		var c = document.querySelector('.cross-product__input-text--candles'); if (activeEmpty(c)) { flashEl(c); return true; }
		var zw = document.querySelector('[data-batida-zw-input]'); if (zw && emptyVal(zw)) { try { zw.classList.add('batida-zw-error'); } catch (e) {} flashEl(zw); return true; }
		return false;
	}

	function readCtaLabel() {
		var atc = inlineAtc();
		if (!atc) return 'Dodaj do koszyka';
		var ready = atc.querySelector('.btn-state-ready');
		var clone = (ready || atc).cloneNode(true);
		clone.querySelectorAll('.batida-atc-arrow, [data-button-price]').forEach(function (n) { n.remove(); });
		var t = clone.textContent.replace(/\s+/g, ' ').replace(/[•·]\s*$/, '').trim();
		return t || 'Dodaj do koszyka';
	}

	function readPrice() {
		var p = q(PRICE_SEL);
		return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
	}

	/* BS-138 (2026-06-10): "Średnica" was hardcoded, so the sticky subtitle
	   leaked Polish on EN/DE/FR/UK. Localize the word via html[lang] — same
	   per-locale pattern as BS-110, no theme translation keys needed. */
	function sizeWord() {
		var lang = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
		var map = { pl: 'Średnica', en: 'Diameter', de: 'Durchmesser', fr: 'Diamètre', uk: 'Діаметр' };
		return map[lang] || map.pl;
	}

	function readSize() {
		var c = q(SIZE_SEL);
		if (!c) return '';
		var m = (c.textContent || '').match(/(\d+)\s*(?:cm|см)/i);
		return m ? (sizeWord() + ' ' + m[1] + ' cm') : '';
	}

	function readThumb() {
		var img = q(IMG_SEL);
		return img && img.currentSrc ? img.currentSrc : '';
	}

	function build() {
		if (document.getElementById(BAR_ID)) return;
		if (!inlineAtc()) return;
		var bar = document.createElement('div');
		bar.id = BAR_ID;
		bar.setAttribute('aria-hidden', 'true');
		bar.innerHTML =
			'<div class="bsd-inner">' +
				'<img class="bsd-thumb" alt="" aria-hidden="true" />' +
				'<div class="bsd-meta">' +
					'<div class="bsd-name"></div>' +
					'<div class="bsd-sub"></div>' +
				'</div>' +
				'<button type="button" class="bsd-cta"></button>' +
			'</div>';
		document.body.appendChild(bar);

		var name = (q(TITLE_SEL) || {}).textContent || '';
		bar.querySelector('.bsd-name').textContent = name.replace(/\s+/g, ' ').trim();

		bar.querySelector('.bsd-cta').addEventListener('click', function (e) {
			var inline = inlineAtc();
			if (!inline || atcBlocked()) {
				e.preventDefault();
				e.stopPropagation();
				var handled = flashBlocked() || (window.batidaPerso && typeof window.batidaPerso.flashBlocker === 'function' && window.batidaPerso.flashBlocker());
				if (!handled && inline) {
					try { inline.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e2) {}
				}
				return;
			}
			inline.click();
		});
	}

	function syncContent() {
		var bar = document.getElementById(BAR_ID);
		if (!bar) return;
		var cta = bar.querySelector('.bsd-cta');
		var sub = bar.querySelector('.bsd-sub');
		var thumb = bar.querySelector('.bsd-thumb');
		var atc = inlineAtc();

		var label = readCtaLabel();
		var price = readPrice();
		var ctaText = price ? (label + ' · ' + price) : label;
		if (cta.textContent !== ctaText) {
			// 29.09: the price keeps its lowercase "zł" inside the uppercase button ("DODAJ DO KOSZYKA · 155,00 zł")
			cta.textContent = price ? label + ' · ' : label;
			if (price) { var ps = document.createElement('span'); ps.className = 'bsd-cta__price'; ps.textContent = price; cta.appendChild(ps); }
		}
		cta.disabled = atcBlocked();

		var size = readSize();
		if (sub.textContent !== size) { sub.textContent = size; sub.style.display = size ? '' : 'none'; }

		var src = readThumb();
		if (src && thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
	}

	/* Hide only once the user is actually entering the footer (its top has
	   risen into the lower half of the viewport), not the instant its top edge
	   appears. On a tall viewport + short PDP the footer peeks in while a whole
	   screen of product/upsell content is still above it; hiding then would mean
	   the bar never shows at all. */
	function nearFooter() {
		var f = q(FOOTER_SEL);
		if (!f) return false;
		return f.getBoundingClientRect().top < window.innerHeight * 0.5;
	}

	/* Out-of-zone (postcode gate): the theme wraps the ATC in
	   .product__submit__buttons.batida-zip-blocked and hides the real ATC's
	   ready state, showing a "Wysyłka niedostępna" label instead. The product
	   can't be added inline, so don't offer it on the sticky bar either. */
	function isBlocked() {
		var atc = inlineAtc();
		if (!atc) return true;
		var wrap = atc.closest('.product__submit__buttons');
		return !!(wrap && wrap.classList.contains('batida-zip-blocked'));
	}

	function syncVisibility() {
		var bar = document.getElementById(BAR_ID);
		if (!bar) return;
		var atc = inlineAtc();
		if (!atc) { bar.classList.remove('is-visible'); return; }
		var rect = atc.getBoundingClientRect();
		var atcOut = rect.bottom < 0 || rect.top > window.innerHeight;
		var show = atcOut && !nearFooter() && !isBlocked();
		bar.classList.toggle('is-visible', show);
		bar.setAttribute('aria-hidden', show ? 'false' : 'true');
	}

	function init() {
		if (!inlineAtc()) return;
		injectStyles();
		build();
		syncContent();
		syncVisibility();

		window.addEventListener('scroll', syncVisibility, { passive: true });
		window.addEventListener('resize', syncVisibility);
		document.addEventListener('theme:variant:change', syncContent);
		document.addEventListener('theme:cart:change', syncContent);

		var t = null;
		function sched() { clearTimeout(t); t = setTimeout(syncContent, 60); }
		document.addEventListener('input', sched, true);
		document.addEventListener('change', sched, true);
		document.addEventListener('click', sched, true);
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
